const useStyles = {
  outerContainer: {
    marginTop: 2,
  },
  centeredRow: {
    justifyContent: 'center',
  },
}

export default useStyles
